import React from 'react';
import { Globe, ArrowRight } from 'lucide-react';

const MigrationModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleRedirect = () => {
    window.location.href = 'https://cova.cliffmutinda.com';
  };

  return (
    <div 
      className="modal fade show" 
      style={{ 
        display: 'block', 
        backgroundColor: 'rgba(15, 23, 42, 0.75)', 
        backdropFilter: 'blur(6px)',
        zIndex: 1050 
      }} 
      tabIndex="-1" 
      role="dialog" 
      aria-modal="true"
      aria-labelledby="migration-modal-title"
    >
      <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '480px', padding: '1.5rem' }}>
        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '16px', overflow: 'hidden' }}>
          
          {/* Top colored accent line */}
          <div className="w-100" style={{ height: '6px', background: 'linear-gradient(90deg, #3b82f6, #6366f1)' }}></div>
          
          <div className="modal-body p-4 p-md-5 text-center">
            
            {/* Styled Icon Wrapper */}
            <div 
              className="d-inline-flex align-items-center justify-content-center mb-4 rounded-circle"
              style={{
                width: '72px',
                height: '72px',
                background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(99, 102, 241, 0.12))',
                color: '#3b82f6'
              }}
            >
              <Globe size={36} />
            </div>
            
            <h3 
              id="migration-modal-title" 
              className="fw-bold mb-3 text-dark"
              style={{ letterSpacing: '-0.02em' }}
            >
              COVA has moved!
            </h3>
            
            <p className="text-muted mb-4 px-1" style={{ fontSize: '15px', lineHeight: '1.6' }}>
              We have migrated to a new domain to provide a faster, more secure, and improved experience. Please access the new platform using the link below:
            </p>
            
            {/* Domain display card */}
            <div 
              className="p-3 mb-4 rounded-3 text-center"
              style={{
                backgroundColor: '#f8fafc',
                border: '1px solid rgba(59, 130, 246, 0.15)'
              }}
            >
              <span className="fw-semibold text-primary" style={{ fontSize: '16px' }}>
                cova.cliffmutinda.com
              </span>
            </div>
            
            {/* Action buttons */}
            <div className="d-grid gap-2">
              <button 
                type="button" 
                className="btn btn-primary py-3 fw-bold d-flex align-items-center justify-content-center gap-2"
                onClick={handleRedirect}
                aria-label="Go to the new COVA domain"
                style={{
                  borderRadius: '10px',
                  background: 'linear-gradient(135deg, #3b82f6, #4f46e5)',
                  border: 'none',
                  transition: 'transform 0.1s ease, filter 0.1s ease',
                  fontSize: '16px'
                }}
                onMouseOver={(e) => e.currentTarget.style.filter = 'brightness(1.08)'}
                onMouseOut={(e) => e.currentTarget.style.filter = 'brightness(1)'}
              >
                <span>Go to New COVA</span>
                <ArrowRight size={18} />
              </button>
              
              <button 
                type="button" 
                className="btn btn-link mt-2 text-decoration-none text-secondary fw-medium"
                onClick={onClose}
                aria-label="Dismiss migration notice and stay on this page"
                style={{ fontSize: '14px' }}
                onMouseOver={(e) => e.currentTarget.style.color = '#334155'}
                onMouseOut={(e) => e.currentTarget.style.color = '#64748b'}
              >
                Stay on Old Version
              </button>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default MigrationModal;
